import { all } from 'redux-saga/effects';

import auth from './auth/sagas';
import distributor from './distributor/sagas';

export default function* rootSaga(): Generator<any> {
  return yield all([auth, distributor]);
}
